var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SrOnly } from '../sr-only';
import { smartPlacement } from '../lib-smartPlacement';
import { DEFAULT_TOOLTIP_I18N } from '../lib-tooltip';
import { randomId } from '../lib-randomId';
import { findTargetForAngular } from '../lib-findTargetForAngular';
import { assignTabindex } from '../lib-assigneTabindex';
import { isMobileDevice } from '../lib-isMobileDevice';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var FOCUSABLE_ELEMENTS = [
    'button',
    'a',
    'input',
    'textarea',
    'select',
    'datalist',
];
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.tooltipElementRef = React.createRef();
        _this.cgThrottle = componentApi.cgThrottle.bind(_this);
        _this.toCancel = [];
        _this.cgSetTimeout = componentApi.cgSetTimeout.bind(_this);
        _this.templates = [
            { name: 'tooltipBody', description: 'The tooltip body content.' },
            { name: 'tooltipFooter', description: 'The tooltip footer content.' },
        ];
        _this.resizeObserver = { unobserve: function () { }, disconnect: function () { } };
        _this.disableObserver = true;
        _this._target = null;
        _this.runningAnimationId = null;
        _this.runningAnimationFrameId = null;
        _this.animationOffset = 12;
        _this.hasTargetOwnTabindex = false;
        _this.stages = {
            inDom: {
                opening: true,
                open: true,
                closing: true,
                closed: false,
            },
            open: {
                opening: true,
                open: true,
                closing: false,
                closed: false,
            },
        };
        _this.observerCallback = _this.cgThrottle(function () {
            _this.setTooltipPlacement(true);
        });
        _this.handleMouseEnter = function () {
            if (_this.tooltipTimer) {
                clearTimeout(_this.tooltipTimer);
            }
            _this.tooltipTimer = _this.startHoverTime();
        };
        _this.handleFocusIn = function (event) {
            if (_this.tooltipTimer) {
                clearTimeout(_this.tooltipTimer);
            }
            _this.tooltipTimer = _this.startFocusinTime(event);
        };
        _this.handleTooltipHide = function () {
            clearTimeout(_this.tooltipTimer);
            _this.hideTooltip(true);
        };
        _this.setTooltipPlacement = function (isVisible) {
            var active = _this.isInStage('inDom');
            var target = _this._target;
            var tooltipElement = _this.tooltipElementRef;
            var tooltipEl = tooltipElement && tooltipElement.current;
            if (!active || !target || !tooltipElement || !tooltipEl) {
                return;
            }
            var placementOptions = _this.props.placementOptions;
            var positions = _this.resolvePositionsPriority(placementOptions.positions);
            var offsets = _this.resolveDefaultOffsets(placementOptions.offsets);
            /*
             * When tooltip is opened it is shifted by animationOffset.
             * To preserve that offset during resize and scroll we correct final offset by animationOffset.
             */
            var rects = Array.from(target.getClientRects());
            // check whether the text occupies more than one line.
            var isMultiline = rects[0].top !== rects[rects.length - 1].top;
            var hasText = rects.length > 1 && isMultiline;
            var actualPosition = smartPlacement(target, tooltipEl, offsets, positions, function (newPosition, coordinates) {
                return isVisible && _this.state.animation === 'open'
                    ? _this.correctOffsetsOfVisible(_this.state._position, newPosition, coordinates)
                    : coordinates;
            }, hasText && _this.props.mode !== 'interactive' && !_this.isControlled());
            _this.writeState('_position', actualPosition);
            if (['indicator', 'description'].includes(_this.props.mode)) {
                _this.tooltip().addEventListener('mouseenter', _this.handleTooltipMouseMoveIn);
                _this.tooltip().addEventListener('mouseleave', _this.handleTooltipMouseMoveOut);
            }
        };
        _this.setTooltipPlacementOfVisible = _this.cgThrottle(function () {
            _this.resizeObserver.unobserve(_this.tooltip());
            _this.setTooltipPlacement(true);
            _this.disableObserver = true;
            _this.resizeObserver.observe(_this.tooltip());
        });
        _this.handleTooltipMouseMoveIn = function () {
            _this.writeState('isTooltipHovered', true);
        };
        _this.handleTooltipMouseMoveOut = function () {
            _this.writeState('isTooltipHovered', false);
            _this.hideTooltip(true);
        };
        _this.showTooltip = function () {
            if (isMobileDevice() && _this.props.mode !== 'interactive')
                return;
            _this.showTooltipHelper();
        };
        _this.showTooltipDueFocusin = function (e) {
            // if event was not called by returning focus to the element,
            // e.g when we close modal focus returns to the button and
            // tooltip does not need to be shown
            if (e.target.matches(':focus-visible')) {
                _this.showTooltip();
            }
        };
        _this.showTooltipHelper = function () {
            _this.emit(_this.userRequest, true);
            var startAnimation = function () {
                if (!_this.isControlled()) {
                    if (!_this.isInStage('open') && _this.tooltip()) {
                        _this.writeState('animation', 'opening');
                        _this.getA11yAttributes();
                        _this.emit(_this.openBegin);
                    }
                }
            };
            if (_this.props.mode === 'interactive') {
                _this.cgSetTimeout(function () {
                    _this.writeState('isContentShown', true);
                    startAnimation();
                    _this.tooltip().addEventListener('keydown', _this.handleKeydownEvent);
                }, 100);
            }
            else {
                startAnimation();
            }
        };
        _this.hideTooltipHelper = function () {
            // this case checks whether the user wants to hover tooltip target button when tooltip body is hovered
            // and we don't want to close the tooltip, instead keep it open
            if (_this._target &&
                _this._target.matches(':hover') &&
                _this.props.mode !== 'interactive') {
                return;
            }
            _this.emit(_this.userRequest, false);
            if (_this.props.mode === 'interactive') {
                _this.cgSetTimeout(function () {
                    _this.writeState('isContentShown', false);
                }, 100);
            }
            if (!_this.isControlled() && !_this.state.isTooltipHovered) {
                if (_this.tooltip()) {
                    _this.tooltip().removeEventListener('keydown', _this.handleKeydownEvent);
                }
                if (_this.tooltip() &&
                    ['indicator', 'description'].includes(_this.props.mode)) {
                    _this.tooltip().removeEventListener('mouseenter', _this.handleTooltipMouseMoveIn);
                    _this.tooltip().removeEventListener('mouseleave', _this.handleTooltipMouseMoveOut);
                }
                if (_this.isInStage('open') && _this.tooltip()) {
                    _this.writeState('animation', 'closing');
                    _this.emit(_this.closeBegin);
                }
                else if (_this.state.animation === 'closed') {
                    _this.writeState('animation', 'closed');
                    _this.emit(_this.closeBegin);
                    _this.emit(_this.closeEnd);
                }
                else if (_this.state.animation === 'closing') {
                    _this.writeState('animation', 'closing');
                }
            }
        };
        _this.hideTooltip = function (isHoverEvent) {
            if (isHoverEvent === void 0) { isHoverEvent = false; }
            if ((['indicator', 'description'].includes(_this.props.mode) &&
                !isHoverEvent) ||
                _this.props.mode === 'interactive') {
                _this.hideTooltipHelper();
            }
            else {
                var delayTime = _this.props.closeDelay;
                _this.cgSetTimeout(_this.hideTooltipHelper, delayTime);
            }
        };
        _this.toggleTooltip = function (event) {
            if (_this.isInStage('open')) {
                _this.hideTooltip();
            }
            else {
                _this.showTooltip();
            }
        };
        _this.mouseDownOutside = false;
        _this.handleOutsideClick = function (event) {
            var tooltipEl = _this.tooltip();
            var isTargetInteractiveElBorder = tooltipEl === event.target;
            var tooltipContentEl = tooltipEl && (tooltipEl === null || tooltipEl === void 0 ? void 0 : tooltipEl.querySelector('.cg-tooltip-content'));
            var active = _this.isInStage('open');
            if (tooltipContentEl &&
                !isTargetInteractiveElBorder &&
                !tooltipContentEl.contains(event.target) &&
                active &&
                !_this._target.isEqualNode(event.target) &&
                !_this._target.contains(event.target)) {
                if (event.type === 'mousedown') {
                    _this.mouseDownOutside = true;
                    return;
                }
                if (_this.mouseDownOutside) {
                    _this.hideTooltip();
                    _this.mouseDownOutside = false;
                }
            }
        };
        _this.handleKeydownEvent = function (e) {
            var active = _this.isInStage('open');
            if ((e.key === 'Escape' || e.key === 'Esc') && active) {
                _this.hideTooltip();
            }
        };
        _this.handleKeyupEvent = function (e) {
            var active = _this.isInStage('open');
            var eventTargetId = e.target.getAttribute('id');
            var currentTargetId = _this._target.getAttribute('id');
            var isTooltipFocused = _this.tooltip().contains(document.activeElement);
            if (eventTargetId !== currentTargetId && !isTooltipFocused) {
                _this.hideTooltip();
            }
        };
        _this.userRequest = 'onUserRequest';
        _this.openBegin = 'onOpenBegin';
        _this.openEnd = 'onOpenEnd';
        _this.closeBegin = 'onCloseBegin';
        _this.closeEnd = 'onCloseEnd';
        _this.readTemplate = componentApi.readTemplate.bind(_this);
        _this.state = {};
        _this.state['isTooltipHovered'] = false;
        _this.state['_position'] = _this.props.position;
        _this.state['animation'] = 'closed';
        _this.state['isContentShown'] = false;
        _this.onAnimationEnd = _this.onAnimationEnd.bind(_this);
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _this = this;
        return (React.createElement("span", { ref: this.tooltipElementRef, "data-e2e": this.props.dataE2e, id: this.getTooltipId(), onAnimationEnd: function (event) { return _this.onAnimationEnd(event); }, className: 'cg-tooltip-ctx cg-tooltip-open ' +
                (this.isInStage('inDom') === false ? 'cg-tooltip-hide ' : '') +
                (this.state.animation === 'open' ? 'cg-disable-animation ' : '') +
                (this.props.size === 'auto' ? 'cg-tooltip-autosize ' : '') +
                (this.state.animation === 'closing' ? 'cg-element-closing ' : '') +
                (this.props.mode !== 'interactive' ? 'cg-tooltip ' : '') +
                (this.props.mode === 'description' ? 'cg-tooltip-description ' : '') +
                (this.props.mode === 'interactive' ? 'cg-tooltip-interactive ' : '') +
                (this.props.mode === 'indicator' ? 'cg-tooltip-indicator ' : '') +
                (this.state._position === 'left' ? 'cg-position-left ' : '') +
                (this.state._position === 'top' ? 'cg-position-top ' : '') +
                (this.state._position === 'right' ? 'cg-position-right ' : '') +
                (this.state._position === 'bottom' ? 'cg-position-bottom ' : '') +
                (this.state._position === 'top-left' ? 'cg-position-top-left ' : '') +
                (this.state._position === 'top-right'
                    ? 'cg-position-top-right '
                    : '') +
                (this.state._position === 'bottom-left'
                    ? 'cg-position-bottom-left '
                    : '') +
                (this.state._position === 'bottom-right'
                    ? 'cg-position-bottom-right '
                    : '') }, (this.props.mode === 'interactive' &&
            this.state.isContentShown === true) ||
            this.props.mode !== 'interactive' ? (React.createElement("span", { className: "cg-tooltip-content" },
            React.createElement("span", { "data-e2e": "cg-tooltip-body", className: "cg-tooltip-body" }, this.readTemplate('tooltipBody')[0]),
            this.props.mode === 'interactive' ? (React.createElement(SrOnly, null, this.getI18n().srInteractiveHelperText)) : null,
            this.readTemplate('tooltipFooter')[0])) : null));
    };
    Tooltip.prototype.getA11yAttributes = function () {
        var tooltipMode = this.props.mode;
        if (['indicator', 'description'].includes(tooltipMode) && this.tooltip()) {
            this.tooltip().setAttribute('role', 'tooltip');
        }
        else if (tooltipMode === 'interactive' && this.tooltip()) {
            this.tooltip().setAttribute('role', 'status');
        }
    };
    Tooltip.prototype.tooltip = function () {
        return this.tooltipElementRef ? this.tooltipElementRef.current : null;
    };
    Tooltip.prototype.isInStage = function (stage) {
        return this.stages[stage][this.state.animation];
    };
    Tooltip.prototype.cg_change = function (prevProps) {
        if (prevProps.targetSelector !== undefined &&
            prevProps.targetSelector !== this.props.targetSelector) {
            // close and detach immediately
            this.hideTooltip();
            this.initTarget();
        }
        if (prevProps.isOpen === false && this.props.isOpen === true) {
            this.writeState('animation', 'opening');
            this.emit(this.openBegin);
        }
        else if (prevProps.isOpen === true && this.props.isOpen === false) {
            if (this.isInStage('open')) {
                this.writeState('animation', 'closing');
                this.emit(this.closeBegin);
            }
        }
        else if (prevProps.animation === 'closed' &&
            this.state.animation === 'opening') {
            this.setTooltipPlacement(false);
        }
        if ((prevProps.animation === 'closed' && this.state.animation !== 'closed') ||
            (prevProps.animation === 'closing' && this.state.animation === 'opening')) {
            this.disableObserver = true;
            this.resizeObserver.observe(this.tooltip());
            this.addGlobalEventListeners();
        }
        else if (prevProps.animation !== 'closing' &&
            this.state.animation === 'closing') {
            this.resizeObserver.unobserve(this.tooltip());
            this.removeGlobalEventListeners();
        }
    };
    Tooltip.prototype.onAnimationEnd = function (e) {
        if (e.target !== this.tooltip()) {
            return;
        }
        if (this.state.animation === 'opening') {
            this.writeState('animation', 'open');
            this.emit(this.openEnd);
        }
        else if (this.state.animation === 'closing') {
            this.writeState('animation', 'closed');
            this.emit(this.closeEnd);
        }
    };
    Tooltip.prototype.initTarget = function () {
        var _a;
        if (this.tooltip()) {
            var target = this.props.targetSelector;
            var tooltipDocRefEl = this.tooltip();
            var newTarget = (target === null || target === void 0 ? void 0 : target.trim())
                ? (_a = tooltipDocRefEl.ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelector(target)
                : null;
            if (!newTarget && (target === null || target === void 0 ? void 0 : target.trim())) {
                newTarget = findTargetForAngular(target, tooltipDocRefEl);
            }
            if (!newTarget) {
                console.log('Missing target for selector:', target);
            }
            this.checkTargetOwnTabindex(newTarget);
            var currentTarget = this._target;
            if (newTarget !== currentTarget) {
                if (currentTarget) {
                    this.removeEventListenersFromTarget();
                    this.cleanupTarget();
                }
                if (newTarget) {
                    this.setupTarget(newTarget);
                    this.addEventListenersToTarget();
                }
            }
        }
    };
    Tooltip.prototype.handleTargetHover = function (target) {
        target === null || target === void 0 ? void 0 : target.addEventListener('mouseenter', this.handleMouseEnter);
        target === null || target === void 0 ? void 0 : target.addEventListener('mouseleave', this.handleTooltipHide);
        target === null || target === void 0 ? void 0 : target.addEventListener('focusin', this.handleFocusIn);
        target === null || target === void 0 ? void 0 : target.addEventListener('focusout', this.handleTooltipHide);
    };
    Tooltip.prototype.startHoverTime = function () {
        var _this = this;
        var delayTime = this.props.openDelay;
        return setTimeout(function () { return _this.showTooltip(); }, delayTime);
    };
    Tooltip.prototype.startFocusinTime = function (event) {
        var _this = this;
        var delayTime = this.props.openDelay;
        return setTimeout(function () { return _this.showTooltipDueFocusin(event); }, delayTime);
    };
    Tooltip.prototype.resolvePositionsPriority = function (positions) {
        var requestedPosition = this.props.position;
        var _positions = __spreadArray([], (positions || [
            'bottom',
            'top',
            'left',
            'right',
            'top-left',
            'bottom-left',
            'top-right',
            'bottom-right',
        ]), true);
        return __spreadArray(__spreadArray([], _positions.filter(function (item) { return item === requestedPosition; }), true), _positions.filter(function (item) { return item !== requestedPosition; }), true);
    };
    Tooltip.prototype.resolveDefaultOffsets = function (offsets) {
        var defaultOffsets = {
            top: {
                topOffset: -24,
                leftOffset: 0,
            },
            left: {
                topOffset: 0,
                leftOffset: -24,
            },
            right: {
                topOffset: 0,
                leftOffset: 24,
            },
            bottom: {
                topOffset: 24,
                leftOffset: 0,
            },
            'top-left': {
                topOffset: -24,
                leftOffset: 24,
            },
            'top-right': {
                topOffset: -24,
                leftOffset: 24,
            },
            'bottom-left': {
                topOffset: 24,
                leftOffset: 24,
            },
            'bottom-right': {
                topOffset: 24,
                leftOffset: 24,
            },
        };
        if (offsets) {
            for (var key in offsets) {
                defaultOffsets[key] = __assign(__assign({}, defaultOffsets[key]), offsets[key]);
            }
        }
        return defaultOffsets;
    };
    Tooltip.prototype.correctOffsetsOfVisible = function (currentPosition, newPosition, coordinates) {
        var _this = this;
        var compensate = function (position) {
            switch (position) {
                case 'right':
                    coordinates.left -= _this.animationOffset;
                    break;
                case 'left':
                    coordinates.left += _this.animationOffset;
                    break;
                case 'bottom':
                case 'bottom-left':
                case 'bottom-right':
                    coordinates.top -= _this.animationOffset;
                    break;
                case 'top':
                case 'top-left':
                case 'top-right':
                    coordinates.top += _this.animationOffset;
                    break;
            }
        };
        if (currentPosition !== newPosition) {
            compensate(currentPosition);
        }
        else {
            // Otherwise we compensate new position translate.
            compensate(newPosition);
        }
        return coordinates;
    };
    Tooltip.prototype.addEventListenersToTarget = function () {
        var target = this._target;
        var mode = this.props.mode;
        if (!target) {
            return;
        }
        target.addEventListener('keydown', this.handleKeydownEvent);
        if (mode === 'interactive') {
            target.addEventListener('click', this.toggleTooltip);
        }
        else {
            this.handleTargetHover(target);
        }
    };
    Tooltip.prototype.addGlobalEventListeners = function () {
        var ownerDocument = this.tooltip().ownerDocument;
        var mode = this.props.mode;
        if (mode === 'interactive') {
            ownerDocument.addEventListener('mousedown', this.handleOutsideClick);
            ownerDocument.addEventListener('mouseup', this.handleOutsideClick);
        }
        ownerDocument.defaultView.addEventListener('resize', this.setTooltipPlacementOfVisible);
        ownerDocument.addEventListener('scroll', this.setTooltipPlacementOfVisible);
        ownerDocument.addEventListener('keyup', this.handleKeyupEvent);
    };
    Tooltip.prototype.removeEventListenersFromTarget = function () {
        var target = this._target;
        if (!target) {
            return;
        }
        var mode = this.props.mode;
        target.removeEventListener('keydown', this.handleKeydownEvent);
        if (mode === 'interactive') {
            target.removeEventListener('click', this.toggleTooltip);
        }
        else {
            target.removeEventListener('mouseenter', this.handleMouseEnter);
            target.removeEventListener('mouseleave', this.handleTooltipHide);
            target.removeEventListener('focusin', this.handleFocusIn);
            target.removeEventListener('focusout', this.handleTooltipHide);
        }
    };
    Tooltip.prototype.removeGlobalEventListeners = function () {
        var mode = this.props.mode;
        var ownerDocument = this.tooltip().ownerDocument;
        if (mode === 'interactive') {
            ownerDocument.removeEventListener('mousedown', this.handleOutsideClick);
            ownerDocument.removeEventListener('mouseup', this.handleOutsideClick);
        }
        ownerDocument.defaultView.removeEventListener('resize', this.setTooltipPlacementOfVisible);
        ownerDocument.removeEventListener('scroll', this.setTooltipPlacementOfVisible);
        ownerDocument.removeEventListener('keyup', this.handleKeyupEvent);
    };
    Tooltip.prototype.isControlled = function () {
        return this.props.controlMode === 'controlled';
    };
    Tooltip.prototype.setupTarget = function (target) {
        this._target = target;
        if (target) {
            if (!['interactive', 'indicator'].includes(this.props.mode)) {
                target.setAttribute('aria-describedby', this.getTooltipId());
            }
            if (this.props.mode === 'indicator') {
                target.setAttribute('aria-labelledby', this.getTooltipId());
            }
            var isAutomaticallyFocusableTarget = FOCUSABLE_ELEMENTS.some(function (elem) { return elem === target.tagName.toLowerCase(); });
            if (!isAutomaticallyFocusableTarget && !this.hasTargetOwnTabindex) {
                assignTabindex(target, '0');
            }
        }
    };
    Tooltip.prototype.cleanupTarget = function () {
        var target = this._target;
        if (target) {
            if (this.props.mode !== 'interactive') {
                target.removeAttribute('aria-describedby');
            }
            if (this.props.mode === 'indicator') {
                target.removeAttribute('aria-labelledby');
            }
            if (!this.hasTargetOwnTabindex) {
                target.removeAttribute('tabindex');
            }
        }
        this._target = null;
    };
    Tooltip.prototype.getTooltipId = function () {
        return this.props.id || this.props.identifier || this._id;
    };
    Tooltip.prototype.getI18n = function () {
        return __assign(__assign({}, DEFAULT_TOOLTIP_I18N), this.props.i18n);
    };
    Tooltip.prototype.checkTargetOwnTabindex = function (target) {
        this.hasTargetOwnTabindex = target
            ? target.getAttribute('tabindex') != null
            : false;
    };
    Tooltip.prototype.componentDidMount = function () {
        this._id = randomId();
        this.initTarget();
        this.resizeObserver = new ResizeObserver(this.observerCallback);
        this.getA11yAttributes();
        if (this.props.isOpen) {
            this.writeState('animation', 'opening');
            this.emit(this.openBegin);
            // because of tooltip's content shows after a brief delay
            // need to call showTooltip to set `isContentShown` to true
            if (this.props.mode === 'interactive') {
                this.showTooltip();
            }
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        this.removeEventListenersFromTarget();
        this.removeGlobalEventListeners();
        this.resizeObserver.disconnect();
        this.cleanupTarget();
        this.toCancel.forEach(function (cancelableFunc) {
            cancelableFunc();
        });
    };
    Tooltip.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Tooltip.defaultProps = {
        dataE2e: 'cg-tooltip',
        isOpen: false,
        i18n: DEFAULT_TOOLTIP_I18N,
        controlMode: 'uncontrolled',
        position: 'bottom',
        mode: 'indicator',
        targetSelector: '',
        placementOptions: {
            positions: [
                'bottom',
                'top',
                'left',
                'right',
                'top-left',
                'bottom-left',
                'top-right',
                'bottom-right',
            ],
            offsets: {
                top: {
                    topOffset: -24,
                    leftOffset: 0,
                },
                left: {
                    topOffset: 0,
                    leftOffset: -24,
                },
                right: {
                    topOffset: 0,
                    leftOffset: 24,
                },
                bottom: {
                    topOffset: 24,
                    leftOffset: 0,
                },
                'top-left': {
                    topOffset: -24,
                    leftOffset: 24,
                },
                'top-right': {
                    topOffset: -24,
                    leftOffset: 24,
                },
                'bottom-left': {
                    topOffset: 24,
                    leftOffset: 24,
                },
                'bottom-right': {
                    topOffset: 24,
                    leftOffset: 24,
                },
            },
        },
        openDelay: 250,
        closeDelay: 250,
        size: 'default',
    };
    Tooltip.displayName = 'Tooltip';
    return Tooltip;
}(React.Component));
export { Tooltip };
